module.exports = __webpack_public_path__ + "img/l1.fd7343a1.png";